<template>
  <div class="win-empDataTable">
    <van-popup v-model="showPicker" position="bottom">
      <van-nav-bar
        :title="forminfo.formname"
        left-text=""
        left-arrow
        right-text="查询"
        @click-left="onClickLeft"
        @click-right="onClickRight"
      >
      </van-nav-bar>
      <div class="ydnrBox">
        <div v-for="(list, idx) in fastqueryinfo" :key="idx" class="ydnrList">
          <!-- 文本框 -->
          <van-field
            placeholder="请输入"
            v-if="
              list.controltype == 'edit' &&
                !list.ispoptree &&
                list.poptreename != 'emptree'
            "
            v-model="list.nameval"
            :label="list.chnname"
          />
          <!-- 普通下拉框 测-->
          <van-field
            placeholder="请输入"
            v-else-if="
              list.controltype === 'combobox' &&
                !list.ispoptree &&
                list.listsql != '@selectmonth' &&
                list.listsql != '@selectyear'
            "
            :clickable="list.comdropstyle == 'lsEditList' ? false : true"
            :readonly="list.comdropstyle == 'lsEditList' ? false : true"
            v-model="list.enval"
            :label="list.chnname"
            @click="
              comboboxNoispoptreefocus(list, list.listsql, list.controltype, 1)
            "
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon
                @click.stop="
                  comboboxNoispoptreefocus(
                    list,
                    list.listsql,
                    list.controltype,
                    2
                  )
                "
                name="arrow-down"
              />
            </template>
          </van-field>
          <!-- 表格下拉框  测-->
          <van-field
            placeholder="请输入"
            v-else-if="list.controltype === 'lookupcombobox'"
            clickable
            readonly
            v-model="list.enval"
            :label="list.chnname"
            @click="
              comboboxNoispoptreefocus(list, list.listsql, list.controltype)
            "
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <!-- 下拉框弹出树(非员工树) 测-->
          <van-field
            placeholder="请输入"
            v-else-if="
              list.controltype === 'combobox' &&
                list.ispoptree &&
                list.poptreename != 'emptree' &&
                list.listsql != '@selectmonth' &&
                list.listsql != '@selectyear'
            "
            clickable
            readonly
            v-model="list.treevalue"
            :label="list.chnname"
            @click="showTree(list)"
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <!-- 下拉框弹出树(员工树) 测 -->
          <van-field
            placeholder="请输入"
            v-else-if="
              (list.controltype == 'combobox' || list.controltype == 'edit') &&
                list.ispoptree &&
                list.poptreename === 'emptree' &&
                list.listsql != '@selectmonth' &&
                list.listsql != '@selectyear'
            "
            v-model="list.noValue"
            :label="list.chnname"
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon name="arrow-down" @click="showSelectJobNum(list)" />
            </template>
          </van-field>
          <!-- 年份 测 -->
          <van-field
            placeholder="请输入"
            v-else-if="
              list.controltype === 'combobox' && list.listsql == '@selectyear'
            "
            clickable
            readonly
            v-model="list.fieldvalue"
            :label="list.chnname"
            @click="settingYear(list)"
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <!-- 月份 测 -->
          <van-field
            placeholder="请输入"
            v-else-if="
              list.controltype === 'combobox' && list.listsql == '@selectmonth'
            "
            clickable
            readonly
            v-model="list.fieldvalue"
            :label="list.chnname"
            @click="settingYearMonth(list)"
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <!-- 日期框 测 -->
          <van-field
            placeholder="请输入"
            v-else-if="list.controltype === 'datetime'"
            clickable
            readonly
            v-model="list.Entry"
            :label="list.chnname"
            @click="settingDatetime(list)"
          >
            <template #right-icon>
              <!-- 右边下拉图标 -->
              <van-icon name="arrow-down" />
            </template>
          </van-field>
        </div>
      </div>

      <div style="width: 100%;overflow: hidden;padding: 10px;">
        <div class="table_box" style="overflow: auto;background: #fff;">
          <table ref="table" class="table">
            <tr class="top">
              <th v-if="forminfo.multisel"></th>
              <th v-for="(value, j) in filedData" :key="j">
                <div
                  style="margin: 0 auto;"
                  class="title"
                  :style="
                    value.chnname
                      ? { width: value.width * 4 + 'px' }
                      : 'min-width:90px'
                  "
                >
                  {{ value.chnname }}
                </div>
              </th>
            </tr>
            <tr
              @click="choiceSelect(choice)"
              class="cont"
              :class="{cus:choice.v8h5_choiceSelect}"
              v-for="(choice, i) in tableData"
              :key="i"
            >
              <td v-if="forminfo.multisel">
                <van-checkbox
                  v-model="choice['v8h5_choiceSelect']"
                ></van-checkbox>
              </td>
              <td v-for="(value, j) in filedData" :key="j">
                <template v-if="value.datatype == 'bit'">
                  <div style="display:flex;justify-content: center;">
                    <van-checkbox
                      v-model="choice[value.filednname]"
                      :disabled="true"
                    ></van-checkbox>
                  </div>
                </template>
                <template v-else> {{ choice[value.filednname] }}</template>
              </td>
            </tr>
          </table>
        </div>
        <div
          class="bottomPage"
          style="height: 55px;display: flex;margin-top: 5px;"
        >
          <van-pagination
            class="empPage"
            v-model="currentPage"
            :total-items="total"
            :show-page-size="3"
            force-ellipses
            @change="empDataTableChange"
          />
        </div>
        <div
          class="bottomPage"
          style="height: 35px;display: flex;margin-top: 5px;justify-content: space-between;"
        >
          <div style="display: flex;align-items: center;">
            <van-button
              v-if="forminfo.showtree"
              size="small"
              plain
              type="info"
              icon="cluster-o"
              @click="showTree()"
            ></van-button>
          </div>

          <van-button
            v-if="forminfo.multisel"
            type="info"
            size="small"
            @click="choiceSelect(null)"
            >确定</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 选择人员树弹窗 -->
    <PopTree
      ref="popTreeNode"
      :whichTree="whichTreeName"
      :module="moduleno"
      :multiseltree="false"
      @treeSelectValEvent="treeSelectValEvent"
    ></PopTree>
  </div>
</template>
<script>
import PopTree from "@components/PopTree/index.vue";
import {
  queryGridData,
  getFastQuerySqlFilter,
  GetFilterDropDownList
} from '@api/wx'
import { parseTime, paging,translateCustomQuerySql } from '@/utils'
export default {
  components: {
    PopTree
  },
  props: {
    moduleno: {
      type: [String, Number],
      required: true
    },
    singleSel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      showPicker: false,
      mid: 201,
      tableData: [],
      bfTableData: [],
      filedData: [],
      total: 0, // 进度条 总数
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页多少条数据
      bigArray: [],
      queryparaminfo: [],
      forminfo: [],
      fastqueryinfo: []
    }
  },
  methods: {
    onClickLeft() {
      this.showPicker = false
    },
    onClickRight() {
      this.handleClick()
    },   
    ini() {
      // 初始化控件
      this.tableData=[]
      this.bfTableData=[]
      this.filedData=[]
      this.fastqueryinfo=[]
      this.bigArray=[]
      this.buildTableHeadAndQuery(this.forminfo)
      this.showPicker = true
    },
    // 构造表头+查询条件
    buildTableHeadAndQuery(n) {      
      let arr = [],
        or_fielddatatypelist = []
      const or_query = n.queryfield.split(',') //获取查询字段原始数组
      const or_fieldlist = n.fieldlist.split(',') //获取表头字段原始数组
      const or_chnlist = n.chnlist.split(',') //获取表头中文原始数组
      const or_widthlist = n.widthlist.split(',') //获取表头宽度原始数组
      // 表头 begin
      if (n.fielddatatypelist) {
        or_fielddatatypelist = n.fielddatatypelist.split(',')
      }
      for (let i = 0; i < or_chnlist.length; i++) {
        const filed = {
          chnname: or_chnlist[i],
          width: or_widthlist[i],
          filednname: or_fieldlist[i],
          datatype:
            or_fielddatatypelist.length > 0
              ? or_fielddatatypelist[i]
              : 'nvarchar'
        }
        arr.push(filed)
      }
      this.filedData = arr
      // 表头 end

      //处理查询条件 begin

      const list = or_query.map(pname => {
        let item = {
          autoid: 0,
          procname: '',
          pname: pname,
          controltype: 'edit',
          listsql: '',
          ispoptree: false,
          poptreename: '',
          labelwidth: 40,
          controlwidth: 100,
          breakline: false,
          sqnum: 0
        }

        this.queryparaminfo.forEach(i => {
          if (pname == i.pname) item = i
        })
        or_fieldlist.forEach((field, i) => {
          if (field === pname) item.chnname = or_chnlist[i]
        })

        item.fieldname = pname
        // ---2023-09-09 不要写死根据paraminfo取
        // item.isrange = false
        // item.isconvert = false
        // item.convertsql = ''
        if (!('ispart' in item)) {
          item.ispart = false
          if (item.chnname) {
            const a = item.chnname.substring(0, 1)
            item.ispart = a === '*'
          }
        }

        return item
      })
      const groups = []
      const idxs = [0]
      // 循环查询条件
      for (let [idx, item] of list.entries()) {
        item.showTree = false // 不展示下拉框的树结构
        item.Entry = parseTime(new Date(), '{y}/{m}/{d}') //开始时间
        item.Entry1 = parseTime(new Date(), '{y}/{m}/{d}') //结束时间（不启用范围是空值）
        if (item.isrange) {
          // 换成range
          item.dateRange = [item.Entry, item.Entry1]
        }
        item.nameval = item.defvalue ? item.defvalue : '' //文本框
        item.treevalue = item.defvalue ? item.defvalue : '' //下拉树
        item.enval = item.defvalue ? item.defvalue : '' //普通下拉框
        item.fieldname === 'yymm'
          ? parseTime(new Date(), '{y}{m}')
          : item.defvalue
          ? item.defvalue
          : ''
        if (item.defvalue == '0') {
          item.check = false
        } else {
          item.check = true //复选框
        }
        item.noValue = item.defvalue ? item.defvalue : '' //员工树
        if (item.breakline && idx !== 0) idxs.push(idx)
        if (
          (item.controltype == 'datetime' && item.listsql) ||
          (item.controltype == 'combobox' &&
            item.isrange &&
            item.listsql &&
            (item.fieldname == 'yymm' || item.fieldname == 'yyyy'))
        ) {
          // 日期框设置了默认值
          this.getDefault(item).then(res => {
            console.log(res, 'getDefault')
          })
        }
      }
      this.fastqueryinfo = list
      //处理查询条件 end
      // this.$forceUpdate()
      this.handleClick()
    },
     // 点击员工信息开始查询按钮
    async handleClick() {
      this.pageSize = 10
      let fastquerylist = []
      this.fastqueryinfo.forEach(e => {
        let value1 = ''
        let value2 = ''
        if (e.controltype === 'combobox' && !e.ispoptree) {
          // value1 = e.enval
          if (e.check) {
            value1 = e.enval
            if (e.isrange) {
              value2 = e.enval1
            }
          } else {
            value1 = ''
            value2 = ''
          }
        } else if (
          e.controltype === 'combobox' &&
          e.ispoptree &&
          e.poptreename !== 'emptree'
        ) {
          value1 = e.treevalue
        } else if (e.controltype === 'edit' && !e.ispoptree) {
          // value1 = e.nameval
          if (e.check) {
            value1 = e.nameval
            if (e.isrange) {
              value2 = e.nameval1
            }
          } else {
            value1 = ''
            value2 = ''
          }
        } else if (
          e.controltype === 'datetime' &&
          !e.ispoptree &&
          !e.ispoptree
        ) {
          if (e.check) {
            value1 = e.Entry
            if (e.isrange) {
              value1 = e.dateRange[0]
              value2 = e.dateRange[1]
            }
          } else {
            value1 = ''
            value2 = ''
          }
        } else if (
          e.controltype === 'combobox' &&
          e.ispoptree &&
          e.poptreename === 'emptree'
        ) {
          value1 = e.noValue
        }
        const tj = {
          fieldname: e.fieldname,
          controltype: e.controltype,
          isrange: e.isrange || false,
          isconvert: e.isconvert || false,
          convertsql: e.convertsql || '',
          ispart: e.ispart,
          fieldvalue1: value1,
          fieldvalue2: value2
        }
        fastquerylist.push(tj)
      })
      const resSql = {
        moduleno: this.moduleno,
        userid: this.userInfo.userid,
        username: this.userInfo.username,
        hasempidfield: this.forminfo.hasempidfield,
        querylist: fastquerylist
      }
      // console.log(JSON.stringify(resSql),'resSql');

      const querysql = await getFastQuerySqlFilter(resSql)
      this.getTableData(querysql)
    },
    // 获取表格数据
    getTableData(querysql) {
      this.currentPage = 1
      const newData = []
      const {
        tbname,
        fieldlist,
        specfilter,
        ordersql,
        hasempidfield
      } = this.forminfo
      const params = {
        moduleno: this.moduleno,
        username: this.userInfo.username,
        userid: this.userInfo.userid,
        fastquerylist: '',
        orderbysql: ordersql,
        pagequery: false, // 不分页，前端分页
        pagesize: 10,
        pageindex: 1,
        hasempidfield: hasempidfield,
        mviewname: tbname,
        fieldlist: fieldlist,
        moduleqyfilter: window.fzrKeyWordTrue,
        specfilter: specfilter,
        querysql: querysql,
        treeList: [], // 树结构
        shuaXinType: 'juBu'
      }
      queryGridData(params).then(res => {
        console.log(this.forminfo.fielddatatypelist)
        if (!this.forminfo.fielddatatypelist) {
          res.data.forEach(myJson => {
            for (var val in myJson) {
              if (myJson[val] === true) {
                myJson[val] = '是'
              } else if (myJson[val] === false) {
                myJson[val] = '否'
              }
            }
          })
        }
        if (this.forminfo.multisel) {
          res.data.forEach(myJson => {
            myJson.v8h5_choiceSelect = false
          })
        }
        this.bfTableData = res.data //newData
        this.bigArray = paging(this.pageSize, this.bfTableData)
        this.tableData = this.bigArray[this.currentPage - 1]
      })
    },
    //获取普通下拉框选项
    async getDefault(item) {
      const params = {
        moduleno: this.moduleno,
        username: this.userInfo.username,
        listsql: item.listsql
      }
      await GetFilterDropDownList(params).then(res => {
        if (item.controltype == 'datetime') {
          // 日期框设置了默认值
          if (res.data[0].bd) {
            item.Entry = res.data[0].bd.replace(/-/g, '/')
          }
          if (res.data[0].ed) {
            item.Entry1 = res.data[0].ed.replace(/-/g, '/')
            item.dateRange = [
              res.data[0].bd.replace(/-/g, '/'),
              res.data[0].ed.replace(/-/g, '/')
            ]
          }
        }
      })
      this.$forceUpdate()
      return true
    },
    // 切换页面
    empDataTableChange() {
      this.tableData = this.bigArray[this.currentPage - 1]
    },
    // 单选（行点击） 或者 点击确定按钮
    choiceSelect(obj) {
      if (this.forminfo.multisel) {
        // 多选
        if (obj === null) {
          // 点击【确定】
          const arr = this.bfTableData.filter(e => {
            return e.v8h5_choiceSelect
          })
          // console.log(this.bfTableData, this.tableData,arr, 1111)
          if (arr.length > 0) {
            this.$emit(
              'customQueryReturn',
              arr.map(e => {
                return e[this.forminfo.retfield]
              }), this.forminfo.updatefield
            )
            this.showPicker = false
          }
        }else{
          obj.v8h5_choiceSelect=!obj.v8h5_choiceSelect
        }
      } else {
        // 单选点击行
        this.$emit(
          'customQueryReturn',
          [obj[this.forminfo.retfield]],
          this.forminfo.updatefield
        ) // 发送值给到父组件
        this.showPicker = false
      }
    },
    // 显示树
    showTree(){
      this.whichTreeName = "";     
      this.$refs.popTreeNode.module = this.moduleno;
      this.$refs.popTreeNode.treename = this.forminfo.treename;
      this.$refs.popTreeNode.can_select_tree_field = ''
      this.$refs.popTreeNode.editstate = 2;
      this.$refs.popTreeNode.showEmpTreePop("数据");
    },
    // 确定树的选择
    treeSelectValEvent(data) {
       const querysql = translateCustomQuerySql(this.forminfo, data, this.userInfo)
      this.loading = true
      this.pageSize = 10
      this.getTableData(querysql)
    }
  }
}
</script>
<style lang="less" scoped>
.table_box {
  .table {
    width: 100%;
    border-spacing: 0px;
    border-left: 2px solid #ccc;
    tr {
      th,
      td {
        padding: 6px 10px;
        text-align: center;
        border-bottom: 2px solid #dcdfe6;
        border-right: 2px solid #dcdfe6;

        .comm_box {
          display: flex;
          justify-content: center;

          .boolean_box {
            .van-checkbox {
              justify-content: center;

              /deep/.van-checkbox__icon--checked {
                .van-icon {
                  color: #fff !important;
                  background-color: #1989fa !important;
                  border-color: #1989fa !important;
                }
              }

              /deep/.van-checkbox__icon--disabled .van-icon {
                background-color: #fff;
              }
            }
          }

          .input_box {
            width: 150px;

            .van-cell {
              font-size: 24px;
              border: 2px solid #d2d2d2;
              border-radius: 10px;
              padding: 8px 16px;
            }
          }
        }
      }
    }

    .top {
      position: sticky;
      top: 0;
      font-size: 28px;
      background: #e9f3fd;
      height: 64px;

      th {
        border-top: 2px solid #dcdfe6;
      }
    }

    .cont {
      height: 64px;
      font-size: 24px;
    }
   
    .cont:nth-child(2n-1) {
      background: #f5f5f5;
    }
 .cus.cont{
      background: #1989fa;
    }
    .nodata {
      td {
        font-size: 28px;
      }
    }
  }

  .isLookupcomboboxActiveBg {
    background: #9cd6ff !important;
  }
}
</style>
